import { isMobile } from "../common/utils";
import Swiper from "swiper";

const initialize = async (sectionDatas) => {
  const mobile = isMobile();
  sectionDatas.forEach((sectionData) => {
    const swiper = new Swiper(`#shopify-section-${sectionData.id} .gd-swiper`, {
      slidesPerView: 3,
      spaceBetween: 40,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      breakpoints: {
        0: {
          slidesPerView: 2.1,
          spaceBetween: 16,
        },
        801: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  });
};

/*
 * main
 */

document.addEventListener("DOMContentLoaded", () => {
  if (window.gd.template != "index" || !window.gd.sections) {
    return;
  }
  const sectionDatas = window.gd.sections.filter((s) => s.type == "top-blog");
  if (sectionDatas.length <= 0) {
    return;
  }
  initialize(sectionDatas);
});
